import isBanner from '../../../assets/images/banner/banner-is@2x.png';
import { LANDING_TYPE } from '../../types/types';

// deprecated
export const BANNER: { [index: string]: any; [count: number]: any } = {
  2: {
    skt: {
      start: '20230508100000',
      end: '2023050823595959',
      banner: {
        imageUrl: isBanner,
        abTestGroup: '',
        bannerSeq: 0,
        landingType: LANDING_TYPE.in_link,
        landingDestination: '/skt/promotion/2',
      },
    },
    kt: {
      start: '20230417000000',
      end: '2023053123595959',
      banner: {
        imageUrl: isBanner,
        abTestGroup: '',
        bannerSeq: 0,
        landingType: LANDING_TYPE.in_link,
        landingDestination: '/kt/promotion/2',
      },
    },
    lgu: {
      start: '20230417000000',
      end: '2023053123595959',
      banner: {
        imageUrl: isBanner,
        abTestGroup: '',
        bannerSeq: 0,
        landingType: LANDING_TYPE.in_link,
        landingDestination: '/lgu/promotion/2',
      },
    },
  },
};
